// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rowlet: PokeData = {
  "id": 722,
  "name": "rowlet",
  "height": 3,
  "weight": 15,
  "base_experience": 64,
  "types": [
    PokeType.GRASS,
    PokeType.FLYING
  ],
  "api_moves": [
    "gust",
    "fury-attack",
    "tackle",
    "growl",
    "peck",
    "razor-leaf",
    "foresight",
    "synthesis",
    "feather-dance",
    "astonish",
    "aerial-ace",
    "magical-leaf",
    "leaf-blade",
    "roost",
    "pluck",
    "sucker-punch",
    "air-slash",
    "brave-bird",
    "nasty-plot",
    "shadow-sneak",
    "leaf-storm",
    "ominous-wind",
    "leafage"
  ],
  "moves": [
    "gust",
    "tackle",
    "growl",
    "peck",
    "razor-leaf",
    "synthesis",
    "aerial-ace",
    "roost",
    "air-slash",
    "brave-bird",
    "shadow-sneak",
    "aromatherapy",
    "bullet-seed"
  ],
  "evolution_chain": {
    "id": 374,
    "item": null,
    "species": [
      {
        "name": "rowlet",
        "order": 722,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "dartrix",
        "order": 723,
        "types": [
          PokeType.GRASS,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 722,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "decidueye",
        "order": 724,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 723,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 34,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60.25,
    "speed": 42,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
